import type { GoFullscreenMessage } from './model/presenter-messages'
import {
	PresentationStorage,
	sessionPresentationStorage,
} from './presentation-storage'
import {
	clickStillActive,
	delegateFullscreen,
	enterOwnFullscreen,
	leaveOwnFullscreen,
	openProjectorWindow,
	readScreens,
} from './window-management'

export type Clock = {
	now: () => number
	setTimeout: (callback: () => void, ms: number) => number
	clearTimeout: (id: number) => void
}

/**
 * Everything the console's effects touch outside themselves. The browser's
 * by default (`BROWSER_CONSOLE_PORTS`); tests pass fakes.
 */
export type ConsolePorts = {
	openWindow: (url: string, name: string, features: string) => Window | null
	delegateFullscreen: (target: Window, message: GoFullscreenMessage) => void
	enterFullscreen: () => Promise<void>
	leaveFullscreen: () => Promise<void>
	clickStillActive: () => boolean
	readScreens: () => Promise<ScreenDetails | undefined>
	storage: PresentationStorage
	clock: Clock
	randomId: () => string
}

export const BROWSER_CONSOLE_PORTS: ConsolePorts = {
	openWindow: openProjectorWindow,
	delegateFullscreen,
	enterFullscreen: enterOwnFullscreen,
	leaveFullscreen: leaveOwnFullscreen,
	clickStillActive,
	readScreens,
	storage: sessionPresentationStorage,
	clock: {
		now: () => Date.now(),
		setTimeout: (callback, ms) => window.setTimeout(callback, ms),
		clearTimeout: id => window.clearTimeout(id),
	},
	randomId: () => Math.random().toString(36).slice(2, 10),
}
